import React, { Component } from "react";
import { generate } from "shortid";

import "./GridBackground.scss";

function range(length) {
  const result = [];

  for (let i = 0; i < length; i++) {
    result.push(length);
  }

  return result;
}

class GridBackground extends Component {
  BOX_SIZE = 25;

  ref = null;

  state = {
    height: 0,
    width: 0
  };

  componentDidMount() {
    this.setDimensions();

    window.addEventListener("resize", () => {
      this.setDimensions();
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => {
      this.setDimensions();
    });
  }

  setRef = ref => {
    if (!this.ref) {
      this.ref = ref;
    }
  };

  setDimensions = () => {
    console.log(this.ref.clientHeight);

    this.setState({
      height: this.ref.clientHeight,
      width: this.ref.clientWidth
    });
  };

  render() {
    const { width, height } = this.state;

    const items = parseInt(
      (height * width) / (this.BOX_SIZE * this.BOX_SIZE),
      10
    );
    const grid = range(isNaN(items) || !items ? 0 : items, "");

    return (
      <div ref={this.setRef} className="grid-background">
        {grid.map(() => <div key={generate()} className="grid__item" />)}
      </div>
    );
  }
}

export default GridBackground;
